<template>
  <footer class="footer-bar">
    <div class="footer-container" ref="footerContainer">
      <div class="footer-main">
        <!-- 在线购买 -->
        <div class="footer-contact">
          <div class="footer-left">在线购买：</div>
          <div class="contact-list-1">
            <div v-for="(item, index) in buyList" :key="index" class="contact-item" @click="buyClick(item)"
              @mouseenter="showQr($event, item.qrCode, item.link)" @mouseleave="hoverItem = ''">
              <img :src="item.img" alt="" v-if="item.img" class="item-img">
              <div>{{ item.title }}</div>
            </div>
          </div>
        </div>

        <!-- 联系我们 -->
        <div class="footer-contact">
          <div class="footer-left">联系我们：</div>
          <div class="contact-list">
            <div v-for="(item, index) in contactList" :key="index" class="contact-item"
              @mouseenter="showQr($event, item.qrCode)" @mouseleave="hoverItem = ''">
              <img :src="item.img" v-if="item.img" alt="" class="item-img">
              <div>{{ item.title }}</div>
            </div>
          </div>
        </div>

        <!-- 公司信息 -->
        <div class="footer-links">
          <div>公司名称:珠海横琴东阳光冬虫夏草科技发展有限公司</div>
          <div>备案号: <a class="bei-box">粤ICP备 15070469号</a></div>
        </div>
        <div class="footer-links">
          <div>联系电话:400-183-9888</div>
        </div>
      </div>

      <!-- 悬浮二维码浮窗 -->
      <div v-if="hoverItem" class="qr-popup" :style="{ top: qrTop + 'px', left: qrLeft + 'px' }">
        <img :src="hoverItem" alt="二维码">
      </div>

    </div>
  </footer>
</template>

<script setup>
import { ref } from 'vue'

const hoverItem = ref('') // 当前显示二维码的 URL
const hoverLink = ref('') // 当前显示二维码的 URL
const qrTop = ref(0)
const qrLeft = ref(0)
const footerContainer = ref(null)

const showQr = (event, qrCode, link) => {
  hoverItem.value = qrCode
  hoverLink.value = link
  const containerRect = footerContainer.value.getBoundingClientRect()
  const targetRect = event.currentTarget.getBoundingClientRect()

  // 计算相对于 footer-container 的位置
  qrLeft.value = (targetRect.left - containerRect.left + targetRect.width / 2) - 50
  qrTop.value = targetRect.top - containerRect.top - 50 // 浮窗在条目上方
}
const buyClick = (item) => {
  if (item.link=="") {
    return
  }
  window.open(item.link, '_blank')

}


const buyList = ref([
  { title: '天猫东阳光补己旗舰店', img: "https://youke1.picui.cn/s1/2025/08/26/68adb930d7e9c.png", link: "https://dongyangguang.tmall.com/shop/view_shop.htm?spm=a220m.1000862.1000725.8.47f81187E2HWip&user_number_id=3166370481&rn=7d5fff1017e6283c5a616b90ed599adc" },
  { title: '京东东阳光补己旗舰店', img: "https://youke1.picui.cn/s1/2025/08/26/68adb92d3994d.png", link: "" }

])

const contactList = ref([
  { title: '官方微信', img: "https://youke1.picui.cn/s1/2025/08/26/68adb92d39bb2.png", qrCode: "https://youke1.picui.cn/s1/2025/08/28/68b06bc4cb89b.png" },
  { title: '官方微博', img: "https://youke1.picui.cn/s1/2025/08/26/68adb92d2a5d5.png", qrCode: "https://youke1.picui.cn/s1/2025/08/28/68b06bc4cb89b.png" },
  { title: '官方抖音', img: "https://youke1.picui.cn/s1/2025/08/26/68adb92d04f47.png", qrCode: "https://youke1.picui.cn/s1/2025/08/28/68b06bc4cb89b.png" },
  { title: '官方小红书', img: "https://youke1.picui.cn/s1/2025/08/26/68adb92d10afd.png", qrCode: "https://youke1.picui.cn/s1/2025/08/28/68b06bc4cb89b.png" }
])
</script>

<style scoped>
.item-img {
  width: 25px;
  height: 25px;
  margin-right: 8px;
}

.footer-bar {
  width: 100%;
  background: #51423B;
  color: #DFD5CC;
  padding: 15px 0;
  font-size: 14px;
  min-width: 1400px;
  height: 100px;

}

.footer-container {
  width: 100%;
  margin: 0 auto;
  padding: 0 10px;
  position: relative;
}

.footer-main {
  display: flex;
  justify-content: space-between;
}

.footer-contact {
  min-width: 220px;
  font-size: 14px;
  line-height: 1.8;
  display: flex;
}

.footer-left {
  margin-right: 10px;
  width: 80px;
}

.contact-list {
  display: flex;
  flex-wrap: wrap;
  width: 400px;
}

.contact-list-1 {
  width: 400px;
}

.contact-item {
  width: 50%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 180px;
}

.footer-links a {
  text-decoration: underline;
}

.footer-links a:hover {
  color: #ff6b35;
}

/* 二维码浮窗样式 */
.qr-popup {
  position: absolute;
  transform: translateX(-50%);
  background: white;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.25);
  z-index: 1000;
}

.link-popup {
  position: absolute;
  transform: translateX(-50%);
  background: white;
  color: black;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.25);
  z-index: 1000;
}

.qr-popup img {
  width: 120px;
  height: 120px;
}
</style>
